import React, { useState, Fragment } from 'react'

type FieldValues = {
  name: string, 
  label: string,
  error: any, 
  inputRef: any, 
  defaultValue: boolean,
  type?: string, 
  onChange: any
};

const FieldCheckbox: React.FC<FieldValues> = ({ name, label, error, inputRef, defaultValue, type, onChange }) => {
  const [fieldValue, setFieldValue] = useState(defaultValue);
  const handleChange = (e: any) => {
    setFieldValue(e.target.value);
    onChange(e);
  }
  return (
    <Fragment>
      <div className='i-form-group'>
        <div className="i-checkbox-holder i-single">
          <input type={type || 'checkbox'}
            id={name} 
            ref={inputRef} 
            onChange={handleChange} 
            defaultChecked={defaultValue}
          />
          <label htmlFor={name} dangerouslySetInnerHTML={{__html:label}}></label>
        </div>
        {error ? <div className="i-form-group-text i-has-error">
          {typeof error === 'string' ? error : `This is required`}
        </div> : ''}
      </div>
    </Fragment>
  )
}

export default FieldCheckbox
